export const removeNonAscii = (str: string): string => {
  if (str === null || str === "") return "";
  else str = str.toString();

  return str.replace(/[^\x20-\x7E]/g, "");
};
